module.exports = __webpack_public_path__ + "img/d20061016-1.d6acf5e6.jpg";